import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import { Box, Typography } from "@material-ui/core";
import { sendAdyaUserFeedback } from "../../../../services/indianbank_services/adya_feedback_services";
import { connect } from "react-redux";

// const useStyles = makeStyles({
//   //   root: {
//   //     width: 200,
//   //     display: "flex",
//   //     alignItems: "center",
//   //   },
//   //   ratingLabel: {
//   //     fontSize: "10px",
//   //     marginLeft: "10px",
//   //   },

//   label: {
//     fontSize: "1.8rem",
//   },
// });

function AdyaRating(props) {
  const [value, setValue] = React.useState(0);
  // const [hover, setHover] = React.useState(-1);
  const [isRated, setIsRated] = React.useState(false);
  // const classes = useStyles();

  // Controlled Rating => Simple Rating
  // component="legend"
  return (
    <>
      <Box>
        <Typography component="subtitle1">
          We would really appreciate your feedback.
        </Typography>
        <Typography variant="subtitle2">
          How would you rate your overall experience?
        </Typography>
      </Box>
      <Box component="fieldset" mb={3} borderColor="transparent">
        <Rating
          name="simple-controlled"
          // name="size-large"
          value={value}
          // size="large"
          onChange={(event, newValue) => {
            setValue(newValue);
            setIsRated(true);
            sendAdyaUserFeedback({
              sessionId: props.sessionDetails.session_id,
              adyaRating: newValue,
              adya_rating_timestamp: `${new Date().toLocaleString("en-GB", {
                hour12: true,
              })}`,
              // adya_rating_timestamp: `${new Date().toLocaleString("en-US", {
              //   hour12: true,
              // })}`,
            });
            // console.log(`Rating: ${newValue}`);
          }}
          disabled={isRated}
        />
      </Box>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    logInData: state.logInStatus,
    sessionDetails: state.sessionDetails,
  };
};

export default connect(mapStateToProps)(AdyaRating);
